// extracted by mini-css-extract-plugin
module.exports = {"container":"_2qz-bWgZoAsTUlDZz2nlkN","portionsList":"_31NCXR5FKqSUHnQqic8HuC"};